/*
 * Copyright (c) 2023 Anvilor Solutions LLC - All Rights Reserved.
 *
 * The information and source code contained herein is the exclusive property of
 * Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
 * or in part without the explicit written authorization from Anvilor Solutions LLC.
 */

import { AnvilorFormsApp } from "../anvilor-forms-app-store.service";
import { AnvilorFormsAppStoreContext } from "../anvilor-forms-app-store.service";
import { EelService } from "@anvilor/ngx-eel";
import { Observable } from "rxjs";
import { SelectorBasedOperator } from "./selector-based-operator";
import { SelectorBasedOperatorWithPath } from "./selector-based-operator";
import { RuiStore } from "@anvilor/ngx-rui";
import { EelOperator } from "@anvilor/ngx-eel";
import { EelType } from "@anvilor/ngx-eel";
import { Evaluator } from "@anvilor/ngx-eel";
import { getByPath } from "@anvilor/ngx-core-utils";
import { distinctUntilChangedJson } from "@anvilor/ngx-core-utils";
import { map } from "rxjs/operators";
import { RuiInstance } from "@anvilor/ngx-rui";
import { SubmitFormOperator } from "./submit-form-operators";
import { SubmitFormDisabledOperator } from "./submit-form-operators";

export class AnvilorFormsAppEelOperators {
  private readonly app: AnvilorFormsApp;
  private readonly rui: RuiStore;
  private readonly ruiInstance: RuiInstance;
  private readonly eel: EelService["eel"];

  constructor(app: AnvilorFormsApp, ctx: AnvilorFormsAppStoreContext) {
    this.app = app;
    this.eel = ctx.eel.eel;
    this.rui = ctx.ruiLegacy;
    this.ruiInstance = ctx.ruiInstance;
  }

  registerAll() {
    this.register("is_after_form_close", this.app.openClose.isAfterSurveyClose$);
    this.register("is_before_form_open", this.app.openClose.isBeforeSurveyOpen$);
    this.register("form_is_closed", this.app.openClose.formIsClosed$);
    this.register("form_is_open", this.app.openClose.formIsOpen$);
    this.registerPathed("client_data_value", this.app.store.clientData$);
    this.registerPathed(
      "response_client_data_value",
      this.app.store.submissionClientData$
    );
    this.registerPathed("response_data_value", this.rui.data.root$);
    // Submission for v1 configs: a config's submit button wires its
    // on_click_action / disabled to these (see submit-form-operators.ts).
    this.eel.scope.registerOperators(
      new SubmitFormOperator(this.app, this.ruiInstance),
      new SubmitFormDisabledOperator(this.app, this.ruiInstance)
    );
  }

  private register(id: string, selector$: Observable<any>) {
    const op = new SelectorBasedOperator(id, selector$);
    this.eel.scope.registerOperators(op);
  }

  private registerPathed(id: string, selector$: Observable<any>) {
    const op = new SelectorBasedOperatorWithPath(id, this.app, selector$);
    this.eel.scope.registerOperators(op);
  }
}
